import { render } from "./ConsignmentStockPage.vue?vue&type=template&id=2c4a907a&scoped=true"
import script from "./ConsignmentStockPage.vue?vue&type=script&lang=js"
export * from "./ConsignmentStockPage.vue?vue&type=script&lang=js"

import "./ConsignmentStockPage.vue?vue&type=style&index=0&id=2c4a907a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4a907a"]])

export default __exports__